import React from "react"
import { Link } from 'react-router-dom'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPowerOff, faUserCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faPowerOff)
library.add(faUserCircle)

const Header = ({ name, logout }) => (
    <div>
        <div className="admin-header">
            <div className="header-inner">
                <div className="company-name">
                    <h1>aps cooling</h1>
                </div>
                <div className="setting">
                    <div className="profile">
                        <FontAwesomeIcon icon="user-circle" />
                        <p className="name">{name}</p>
                    </div>
                    <div className="btn-logout">
                        <Link to="#" onClick={logout}>
                                <FontAwesomeIcon icon="power-off" />
                                <p>Log Out</p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

export { Header }